import { Users } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const crmManifest: ModuleDefinition = {
  id: 'crm',
  name: 'CRM',
  icon: <Users size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/crm',
  status: 'active',
  navItems: [
    { label: 'Mijn Dag', path: '/crm/my-day', icon: '☀️' },
    { label: 'Pipeline', path: '/crm', icon: '🔄' },
    { label: 'Taken', path: '/crm/opvolging', icon: '📝' },
    { label: 'Dashboard', path: '/crm/dashboard', icon: '📊' },
  ],
  component: () => import('./index.js'),
};

export default crmManifest;
